define('app/views/yadisa_buy_button_view',['app/setup'], function(takhfifan) {

  takhfifan.YadisaBuyButtonView = Backbone.View.extend({

    events: {
      'click': 'submit'
    },

    initialize: function(options) {
      var _this = this;
      this.productId = options.productId;
      this.isLoading = true;

      takhfifan.eventHub.on('timeover:' + this.productId, function() {
        _this.disable();
        _this.setAsDeactive();
      }, this);

      takhfifan.eventHub.on('groupedProduct:removeAssociate', function(opts) {
        if(_this.productId==opts.productId) {
          _this.disable();
          _this.setAsDeactive();
        }
      }, this);

      takhfifan.eventHub.on('buyButton:enable', function() {
        _this.enableButton();
      }, this);

      takhfifan.eventHub.on('dealseconds:' + this.productId, function(seconds) {
        _this.setAsActive()
      });
    },

    enableButton: function() {
      this.setAsActive();
      this.enable();
    },

    submit: _.once(function(event) {
      event.preventDefault();
      if(!this.isLoading){
        takhfifan.eventHub.trigger('productaddtocart:' + this.productId, this);
        this.setAsLoading();
        this.disable();
      }
      return false;
    }),

    setAsLoading: function() {
      this.isLoading = true;
      this.$el.addClass('loading-view');
    },

    setAsActive: function() {
      this.isLoading = false;
      this.$el.removeClass('loading-view');
    },
    
    setAsDeactive: function() {
      this.$el.addClass('sold-out-view');
      this.$el.find('span.more-info').text('به پایان رسید');
    },

    disable: function() {
      this.undelegateEvents();
      this.$el.attr('disabled', true);
    },

    enable: function() {
      this.delegateEvents();
      this.$el.attr('disabled', false);
    }

  });

});

